import PropTypes from 'prop-types';
export var schedulesShape = PropTypes.shape({
  availability: PropTypes.shape({
    credits: PropTypes.number.isRequired,
    top_up: {
      purchase: {
        amount: PropTypes.number,
        credits: PropTypes.number,
        currency: PropTypes.string,
        taxable: PropTypes.bool
      }
    }
  }),
  class: PropTypes.shape({
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  cancellation_policy: PropTypes.string.isRequired,
  endtime: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  starttime: PropTypes.number.isRequired,
  venue: PropTypes.shape({
    id: PropTypes.number.isRequired,
    address: PropTypes.shape({
      address_line1: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zip_code: PropTypes.string.isRequired
    }).isRequired,
    images: PropTypes.shape({
      default: PropTypes.string
    }),
    late_cancellation: PropTypes.string.isRequired,
    location: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    name: PropTypes.string.isRequired,
    tz: PropTypes.string.isRequired
  }).isRequired
});